<template>
  <esg-base-chart>
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>
    <apex-chart ref="chart"
                type="donut"
                height="250"
                :options="chartOptions"
                :series="series"/>
  </esg-base-chart>
</template>
<script>
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  // 협력사별 온실가스 배출비율
  props: {
    year: {
      type: Number
    },
    product: {
      type: Object,
    },
  },
  components: {
    EsgBaseChart,
  },
  data() {
    return {
      loading: false,
      series: [],
      chartOptions: {
        labels: [],
        chart: {
          type: 'donut',
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                value: {
                  show: true,
                  formatter: val => this.formatNumber(val) + ' tCO2'
                },
                total: {
                  show: true,
                  color: 'black',
                  label: '업스트림 운송 배출량',
                  formatter: chart => chart.config.series.reduce((a, b) => a + b, 0).toFixed(2) + ' tCO2'
                },
              },
            },
          },
        },
        tooltip: {
          y: {
            show: true,
            formatter: val => this.formatNumber(val) + ' tCO2'
          },
        },
        legend: {
          position: 'right',
        },
        dataLabels: {
          enabled: true, //=> 데이터 series값 출력
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom'
              }
            }
          }
        ]
      },
    }
  },
  watch: {
    product: {
      immediate: true,
      deep: true,
      handler() {
        this.fetchData()
      }
    },
    year: {
      immediate: true,
      handler() {
        this.fetchData()
      }
    }
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchData() {
      if (!this.product || !this.product.productFamilyCode || !this.product.productCode || !this.product.name) return
      if (!this.year) return

      try {
        // Chart meta data
        let args = [{
          years: [this.year],
          productFamilies: [this.product.productFamilyCode],
          products: [this.product.productCode],
          groupKeys: ['partner_code', 'partner_name']
        }]

        // Construct form data for HTTP request
        let data = new FormData()
        data.append('path', 'esg/lca/upstream_transportation_detail/main')
        data.append('json', JSON.stringify(args))

        // Request data for the chart
        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        // If there is no data, return
        if (!response.data.data) {
          this.series = [];
          return
        }

        // Parse JSON data
        let chartData = JSON.parse(response.data.data)[0].data;

        // Extract series and labels
        let series = []
        let labels = []
        chartData.forEach(row => {
          series.push(row.values)
          labels.push(row.partner_name)
        })

        this.series = series
        this.chartOptions.labels = labels

      } catch (error) {
        await this.showError(error)
      } finally {
        this.refreshChart()
      }
    },
  }
}
</script>
